import { useEffect } from 'react';

import { Agencies, ContractTypes, HelpTypes, MiscType, setFilterPostedBy, setFilterShiftType, setMapProfessionalType } from '@pharmaplan/common';
import { useAppDispatch } from '../../useAppDispatch';

const useAdminCalendarDropdowns = () => {
  const dispatch = useAppDispatch();

  const handleMenuClick = (val: string) => {
    dispatch(setFilterShiftType(val as ContractTypes | MiscType));
  };

  const handleMapProfessionalFilter = (val: string) => {
    dispatch(setMapProfessionalType(val as HelpTypes | MiscType));
  };

  const handlePostedMenuClick = (val: string) => {
    dispatch(setFilterPostedBy(val as MiscType | Agencies));
  };

  // THE DROPDOWN VALUE IS LOCAL TO THE TOOLBAR, SO THE STORED FILTER MUST RESET WITH IT ON SCREEN CHANGE
  useEffect(() => {
    const resetMapProfessionalFilter = () => {
      dispatch(setMapProfessionalType(MiscType.All));
    };

    return resetMapProfessionalFilter;
  }, [dispatch]);

  return { handleMenuClick, handleMapProfessionalFilter, handlePostedMenuClick };
};

export default useAdminCalendarDropdowns;
